import React from 'react';

const DisplayControlIcon = ({ color = '#0F7F85', width = 24, height = 24 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="3" width="20" height="14" rx="2" stroke={color} strokeWidth="2" />
      <path d="M8 21H16" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M12 17V21" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export default DisplayControlIcon;
